<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0193 22.3092H15.8855C15.7355 22.3092 15.6133 22.1859 15.6133 22.0335V20.817C15.6133 20.6651 15.735 20.5413 15.8855 20.5413H27.0188C27.1688 20.5413 27.291 20.6645 27.291 20.817V22.0335C27.291 22.1859 27.1693 22.3092 27.0193 22.3092Z"
      fill="#0AC16A"
    />
    <path
      d="M29.3682 12.7346C29.3682 12.7346 22.8364 12.7341 21.6824 12.7341C20.8758 11.5697 19.092 10.5553 17.5612 10.5553C16.5703 10.5553 12.7632 10.5553 11.4971 10.5553C10.9819 10.5553 10.5996 10.2791 10.2764 9.96753L5.18042 15.0929C5.80264 15.7344 6.44809 16.3805 6.90415 16.7882C8.09303 17.8517 9.12232 18.462 11.1976 18.4641H17.7718C18.5314 18.4579 19.1273 17.7704 19.0935 17.0302C19.0612 16.2899 18.4137 15.6889 17.6546 15.6955C17.6546 15.6955 14.2258 15.6883 13.8258 15.6899C13.2885 15.6924 12.8799 15.3159 12.8526 14.7593C12.8253 14.2125 13.2556 13.8651 13.6996 13.8365H29.3682C29.6682 13.8365 29.9121 14.0836 29.9121 14.3874V15.2827H19.2652C19.75 15.7057 20.0733 16.3094 20.1026 16.9826C20.1263 17.5064 19.9642 18.0246 19.6652 18.4585H29.9121V24.3486C29.9121 24.6525 29.6682 24.8995 29.3682 24.8995H14.0147C13.7147 24.8995 13.4708 24.6525 13.4708 24.3486V19.4872H12.3829V24.3486C12.3829 25.2602 13.1152 26.0015 14.0147 26.0015H29.3682C30.2682 26.0015 31 25.2597 31 24.3486V14.3874C31 13.4763 30.2677 12.7346 29.3682 12.7346Z"
      :fill="semanticColorLookup('surface.on-surface')"
    />
    <path
      d="M9.97224 8.87468L3.65611 15.2257C3.44096 15.4421 3.09298 15.4273 2.87834 15.1935L1.16067 13.3197C0.946024 13.0859 0.946529 12.7206 1.16168 12.5047L7.4773 6.15316C7.69245 5.93677 8.04043 5.95161 8.25507 6.18539L9.97274 8.05925C10.1874 8.29354 10.1869 8.65829 9.97224 8.87468Z"
      :fill="semanticColorLookup('surface.on-surface')"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsCreditCard'
})
</script>
